export const CLIENT_TYPE_OPTIONS = [
  "Une entreprise ou un CSE",
  "Une association",
  "Une école ou un BDE",
  "Un centre de loisirs",
  "Une mairie ou une collectivité",
  "Un apporteur d’affaires",
] as const;

export type ClientTypeOption = (typeof CLIENT_TYPE_OPTIONS)[number];

const CLIENT_TYPE_ORDER = new Map(
  CLIENT_TYPE_OPTIONS.map((value, index) => [value, index])
);

function normalizeClientTypeKey(value: string): string {
  return value
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

export function normalizeClientType(
  value: string | null | undefined
): ClientTypeOption | null {
  if (!value || typeof value !== "string") return null;

  const key = normalizeClientTypeKey(value);
  if (!key) return null;

  if (key.includes("entreprise") || key.includes("cse")) {
    return "Une entreprise ou un CSE";
  }

  if (key.includes("association")) {
    return "Une association";
  }

  if (key.includes("ecole") || key.includes("bde")) {
    return "Une école ou un BDE";
  }

  if (
    key.includes("centre de loisirs") ||
    key.includes("centre loisirs") ||
    key.includes("loisirs")
  ) {
    return "Un centre de loisirs";
  }

  if (key.includes("mairie") || key.includes("collectivit")) {
    return "Une mairie ou une collectivité";
  }

  if (key.includes("particulier") || key.includes("apporteur")) {
    return "Un apporteur d’affaires";
  }

  return null;
}

export function normalizeClientTypeFilters(
  values: readonly (string | null | undefined)[] | null | undefined
): ClientTypeOption[] | null {
  if (!values || values.length === 0) return null;

  const normalized = Array.from(
    new Set(values.map((value) => normalizeClientType(value)).filter(Boolean))
  ) as ClientTypeOption[];

  if (normalized.length === 0) return null;

  return normalized.sort(sortClientTypes);
}

export function sortClientTypes(a: string, b: string): number {
  const rankA = CLIENT_TYPE_ORDER.get(a as ClientTypeOption);
  const rankB = CLIENT_TYPE_ORDER.get(b as ClientTypeOption);

  if (rankA !== undefined && rankB !== undefined) {
    return rankA - rankB;
  }

  if (rankA !== undefined) return -1;
  if (rankB !== undefined) return 1;

  return a.localeCompare(b, "fr");
}
